import React from 'react';

const SplashLoader = () => {
  return (
    <div className="splash-loader">
      <div className="splash-loader-content">
        <div className="splash-loader-spinner" />
        <p className="splash-loader-text">Loading documents…</p>
      </div>
    </div>
  );
};

export default SplashLoader;
